import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NotifyMeCurrentButton } from '@yme/pdp-components/NotifyMe/NotifyMeCurrentButton';
import { getCommon } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { NotifyMeControl } from './NotifyMeControl';
import { NOTIFY_ME_VARIANTS } from './constants';
import { getNotifyMeLabels } from './helpers';
export function NotifyMe({ sku, stock, labels, eCommerceEnabledAttribute, eCommerceEnabledAttributeForMaster, productCampaignIDAttribute, privacyConsentsModel, productNotifyMeDisclaimer, isCompactView = false, isButtonView = false, }) {
    const [visibleItem, setVisibleItem] = useState(NOTIFY_ME_VARIANTS.disabled);
    const { ecommerceEnabled, isRightToLeft } = useSelector(getCommon);
    const notifyMeLabels = getNotifyMeLabels(labels);
    const backInStockCase = ecommerceEnabled && eCommerceEnabledAttribute;
    const productReleaseAnnouncementCase = productCampaignIDAttribute && !eCommerceEnabledAttributeForMaster;
    const getVisibleItem = useCallback(() => {
        if (backInStockCase) {
            return stock <= 0 ? NOTIFY_ME_VARIANTS.backInStock : NOTIFY_ME_VARIANTS.disabled;
        }
        if (productReleaseAnnouncementCase) {
            return NOTIFY_ME_VARIANTS.productReleaseAnnouncement;
        }
        return NOTIFY_ME_VARIANTS.disabled;
    }, [backInStockCase, productReleaseAnnouncementCase, stock]);
    useEffect(() => {
        setVisibleItem(getVisibleItem());
    }, [backInStockCase, productReleaseAnnouncementCase, stock, sku, getVisibleItem]);
    if (visibleItem === NOTIFY_ME_VARIANTS.disabled) {
        return null;
    }
    return isCompactView ? (React.createElement(NotifyMeCurrentButton, { NotifyMeType: visibleItem, isRightToLeft: isRightToLeft, notifyMeLabels: notifyMeLabels, variantSku: sku, isButtonView: isButtonView, productCampaignIDAttribute: productCampaignIDAttribute, privacyConsentsModel: privacyConsentsModel })) : (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
        React.createElement(NotifyMeControl, { NotifyMeType: visibleItem, isRightToLeft: isRightToLeft, notifyMeLabels: notifyMeLabels, productNotifyMeDisclaimer: productNotifyMeDisclaimer, variantSku: sku, productCampaignIDAttribute: productCampaignIDAttribute, privacyConsentsModel: privacyConsentsModel })));
}
NotifyMe.displayName = 'NotifyMe';
